<template>
    <!-- <Home fit="cover"> -->
    <Home fit="cover">
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/Titelbild.jpg">
            <source media="(orientation: landscape)" srcset="../assets/img/Titelbild.jpg">
        </template>
        <template #headline>Die ISS in 3D</template>
        <template #subline>Entdecken Sie das fliegende Megalabor im All</template>
        <!-- <template #text>
            <p>Hallo. Ich bin ein kleiner Blindtext. Und zwar schon so lange ich denken kann. Es war nicht leicht zu verstehen, was es bedeutet, ein blinder Text zu sein: Man ergibt keinen Sinn. Wirklich keinen Sinn.</p>
            <p>Man wird zusammenhangslos eingeschoben und rumgedreht – und oftmals gar nicht erst gelesen. Aber bin ich allein deshalb ein schlechterer Text als andere? Na gut, ich werde nie in den Bestsellerlisten stehen. Aber andere Texte schaffen das auch nicht. Und darum stört es mich nicht besonders blind zu sein. Und sollten Sie diese Zeilen noch immer lesen, so habe ich als kleiner Blindtext etwas geschafft, wovon all die richtigen und wichtigen Texte meist nur träumen.</p>
        </template> -->
        <template #update>
            06.05.2022
            <br>
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            camera:{
                position: [1.69,2.25,62], // alpha, beta, radius   //22.10. 14h 0,0.2,100
                target: [0,0,1.5],    //0,-2,1                   //22.10. 14h 8,-2,1
                animationSpeed: 10
            },

            iss: {

                Empty: {
                    sonne: {
                        fade: true,
                        visible: false
                    },
                },

                erde_pivot: {
                    erde: {
                        fade: true,
                        visible: false
                    },
                },

                Label_BG_109m: {
                    visible: true,
                    Typo_109m: {
                        visible: true
                    }

                },
                Pfeil_109m: {
                    visible: true,
                },
                

                Label_BG_73m: {
                    visible: true,
                    Typo_73m: {
                        visible: true
                    }

                },
                Pfeil_73m: {
                    visible: true,
                },

                kontur_flugzeug: {
                    visible: true,
                },

                kontur_flugzeug_seite: {
                    visible: true
                },

                kontur_fussballfeld: {
                    visible: true,   
 
                },

                kontur_auto: {
                    visible: true,
                },

                kontur_astronaut: {
                    visible: true,
                },
            }
        },
        babylonReady: function ()
        {

        this.$audioController.initTrack('loop', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);   //'speaker'

        this.$babylonController.setCameraRadiusLimit(8,200);
        this.$babylonController.startAnimation("erde_pivot_anim", true, .01);   //.03
        this.$babylonController.goToAnimation("spacex_anim", 0);
        this.$babylonController.goToAnimation("Solarpanels_rechts_anim", 0);
        this.$babylonController.goToAnimation("Solarpanels_links_anim", 0);
        this.$babylonController.goToAnimation("thermo_rechts_anim", 0);
        this.$babylonController.goToAnimation("thermo_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_1_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_2_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_3_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_4_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_1_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_2_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_3_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_4_links_anim", 0);

        

        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            opacity: 1;  //.85
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>
